import React, { useMemo } from 'react';
import { useEmit } from './fields';

/**
 * Informational prerequisites section. Emits a marker so the parent knows the
 * applicant saw it: { generalInfo, pre_requisites }.
 */
const PREREQS = [
    ['Tenant Identification', 'Provide the tenant’s company details and proof of identity.'],
    ['Work Scope Details', 'Clear description of the work — nature, location, and duration.'],
    ['Safety Measures', 'Safety protocols: equipment, PPE, and emergency procedures.'],
    ['Insurance Coverage', 'Proof of valid liability insurance for damages or injuries.'],
    ['Compliance', 'Adherence to local building codes, fire safety, and health regulations.'],
    ['Work Schedule', 'Proposed date/time, ensuring minimal disruption to mall operations.'],
];

const GeneralDetails = ({ onDataChange }) => {
    const data = useMemo(() => ({ generalInfo: 'acknowledged', pre_requisites: PREREQS.map(p => p[0]).join(', ') }), []);
    useEmit(data, onDataChange);

    return (
        <div className="v3-wp-card">
            <div className="v3-wp-card-head"><h6 className="v3-wp-card-title">General Details — Prerequisites</h6></div>
            <ol style={{ margin: 0, paddingLeft: 18 }}>
                {PREREQS.map(([k, v], i) => (
                    <li key={i} style={{ marginBottom: 8, color: 'var(--v3-text-secondary)', fontSize: 13 }}>
                        <strong style={{ color: 'var(--v3-text-primary)' }}>{k}:</strong> {v}
                    </li>
                ))}
            </ol>
        </div>
    );
};

export default GeneralDetails;
